import axios from "networking/axios/axios";
import * as endpoints from "networking/endpoints/endpoints";

export const getSellerDetailsApi = (id) =>
    Promise.resolve(axios.get(endpoints.getSellerDetails.replace("{id}", id)));
